// extracted by mini-css-extract-plugin
export default {"menu_wrapper":"ShowMenu_menu_wrapper__FV+Df","changePassword":"ShowMenu_changePassword__-NX0s","logout":"ShowMenu_logout__FPdTK","icon":"ShowMenu_icon__ZGN8m"};